import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';
import { useBusinessName } from '../contexts/BusinessContext';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { businessName } = useBusinessName();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      toast.success('Login successful!');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#000000' }}>
      <div className="retro-panel w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-6 md:mb-8">
          <h1 className="text-3xl md:text-5xl font-bold mb-2 glow-text" style={{ color: '#FF6B00', fontFamily: 'Orbitron, sans-serif' }}>
            {businessName}
          </h1>
          <div className="text-lg md:text-xl" style={{ color: '#ffffff' }}>
            [WORK TIME TRACKING SYSTEM v1.0]
          </div>
          <div className="text-base md:text-lg mt-2" style={{ color: '#FF6B00' }}>
            >> LOGIN SEQUENCE
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
          <div>
            <label className="block mb-2 text-lg md:text-xl" style={{ color: '#FF6B00' }}>
              [USERNAME]:
            </label>
            <input
              type="text"
              data-testid="login-username-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="retro-input w-full"
              required
              autoComplete="username"
            />
          </div>

          <div>
            <label className="block mb-2 text-lg md:text-xl" style={{ color: '#FF6B00' }}>
              [PASSWORD]:
            </label>
            <input
              type="password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="retro-input w-full"
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            data-testid="login-submit-button"
            className="retro-btn w-full"
            disabled={loading}
          >
            {loading ? '[PROCESSING...]' : '[LOGIN]'}
          </button>
        </form>

        {/* Footer */}
        <div className="mt-8 text-center text-sm" style={{ color: '#FF6B00' }}>
          <div className="blink">>_</div>
          <div className="mt-2">SYSTEM READY</div>
        </div>
      </div>
    </div>
  );
}